<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="in">est</option>
  </select>

  <div class="ml-2">
    <select [(ngModel)]="filter.tempValue" class="form-control max-width-240px" (ngModelChange)="filterChange.emit(filter)">
      <option [value]="[refundedStatus.TOTALLY_REFUNDED]">avec remboursement</option>
      <option [value]="[refundedStatus.NOT_REFUNDED]">sans remboursement</option>
    </select>
  </div>
</div>
